<div
    [ngClass]="[cardClass(), cardColor()]"
    class="card position-relative d-flex rounded-4"
>
    @if (image() && imageOptimization()) {
    <img
        brandOptimizedImage
        #cardImage
        [alt]="imageAlt()"
        [ngSrc]="image()"
        [ngClass]="imageClass()"
        [sizes]="imageSizes()"
        class="optimized-image position-relative card-img-top mx-auto"
        fill
    />
    } @if (image() && !imageOptimization()) {
    <img
        #cardImage
        [alt]="imageAlt()"
        [src]="image()"
        [ngClass]="imageClass()"
        class="card-img-top mx-auto"
    />
    }
    <div class="card-content markdown">
        @if (title()) {
        <ng-template [ngTemplateOutlet]="headingRef"></ng-template>
        } @if (description()) {
        <div
            #cardDescription
            [translate]="description() || ''"
            [ngClass]="headingClass() && title() ? 'mt-1' : ''"
            behavior="markdown"
            class="card-text mb-0 mt-1"
        ></div>
        } @for (action of actionOrder(); track action) { @switch (action) {
        @case ('video') { @if (modalVideoId()) {
        <div>
            <button
                #cardModalLink
                (click)="openModal(modalVideoId())"
                class="icon-link mt-3"
            >
                <span class="icon-link-icon">
                    <img
                        [src]="'GLOBAL_WATCH-VIDEO_PLAY_ICON_URL' | translate"
                        [alt]="
                            'GLOBAL_WATCH-VIDEO_PLAY_ICON_ALT_TEXT' | translate
                        "
                        class="bi play-icon"
                    />
                </span>
                <span
                    [innerHtml]="'GLOBAL_WATCH-VIDEO_TEXT' | translate"
                ></span>
            </button>
        </div>
        } } @case ('button') { @if (buttonText() && buttonUrl()) {
        <a
            #cardButton
            [brandHref]="buttonUrl()"
            [innerHtml]="buttonText()"
            class="btn btn-outline-primary mt-3"
        ></a>
        } } @case ('link') { @if (linkText() && linkUrl()) {
        <div #cardLink class="col-auto mt-3">
            <a [brandHref]="linkUrl()" class="icon-link p-0">
                <span [innerHtml]="linkText()"></span>
                <span class="icon-link-icon">
                    <img
                        [src]="'GLOBAL_ARROW-RIGHT_ICON_URL' | translate"
                        [alt]="'GLOBAL_ARROW-RIGHT_ICON_ALT_TEXT' | translate"
                        class="bi arrow-icon"
                    />
                </span>
            </a>
        </div>
        } } } }
        <div #cardContent>
            <ng-content></ng-content>
        </div>
    </div>
</div>

<!-- title template partial -->
<ng-template #headingRef let-title="title">
    @if (headingValue() === 1) {
    <h1 #cardTitle [ngClass]="headingClass()" class="card-title mb-0">
        <ng-template [ngTemplateOutlet]="titleTextRef"></ng-template>
    </h1>
    } @if (headingValue() === 2) {
    <h2 #cardTitle [ngClass]="headingClass()" class="card-title mb-0">
        <ng-template [ngTemplateOutlet]="titleTextRef"></ng-template>
    </h2>
    } @if (headingValue() === 3 || !headingValue()) {
    <h3 #cardTitle [ngClass]="headingClass()" class="card-title mb-0">
        <ng-template [ngTemplateOutlet]="titleTextRef"></ng-template>
    </h3>
    } @if (headingValue() === 4) {
    <h4 #cardTitle [ngClass]="headingClass()" class="card-title mb-0">
        <ng-template [ngTemplateOutlet]="titleTextRef"></ng-template>
    </h4>
    } @if (headingValue() === 5) {
    <h5 #cardTitle [ngClass]="headingClass()" class="card-title mb-0">
        <ng-template [ngTemplateOutlet]="titleTextRef"></ng-template>
    </h5>
    }
</ng-template>

<ng-template #titleTextRef>
    <span [innerHtml]="title()"></span>
</ng-template>

@if (modalVideoId() && isBrowser) {
<ng-container>
    @if (modalVideoId()) {
    <brand-modal
        (onClose)="closeModal($event)"
        [id]="modalVideoId()"
        modalDialogClass="modal-video modal-dialog-centered modal-max-width"
        modalContentClass="bg-transparent"
    >
        @if (modalVideoLoaded) {
        <brand-video [videoData]="modalVideoUrl"> </brand-video>
        }
    </brand-modal>
    }
</ng-container>
}
